import { InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
  availableLanguages: Array<{ code: string; name: string }>;
  demoMode: boolean;
}
export const APP_VERSION= 11.0;

export const BaseAppConfig: AppConfig = {
  availableLanguages: [
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'mar',
      name: 'मराठी',
    },
    {
        code: 'hin',
        name: 'हिन्दी',
    }
  ],
  demoMode: false,
};
